import { Check, Text } from '@myinterview/component-library';
import React, { useState } from 'react';
import { IMultipleChoiceOptionDefinition } from '../interfaces/jobInterface';
import { IMultipleAnswer } from '../interfaces/videoInterface';

interface IProps {
  answerOptions: IMultipleChoiceOptionDefinition[];
  onAnswer: (answer: IMultipleAnswer[]) => void;
}

export const AssessmentSingleSelect:React.FC<IProps> = ({ answerOptions, onAnswer }) => {
  const [selectedAnswer, setSelectedAnswer] = useState<IMultipleAnswer[]>(answerOptions.map((answer) => ({ ...answer, selected: false })));
  const handleChange = (e: React.ChangeEvent<HTMLFormElement>) => {
    const _answers: IMultipleAnswer[] = answerOptions.map((answer) => ({ ...answer, selected: answer.id === e.target.value }));
    setSelectedAnswer(_answers);
    onAnswer(_answers);
  };

  return (
    <div className="myinterview-widget-assessment__single-select">
      <form
        className="myinterview-widget-assessment__options-form"
        onChange={handleChange}
      >
        {selectedAnswer.map((answer) => (
          <label
            key={answer.id}
            className="myinterview-widget-assessment__option myinterview-text--S"
          >
            <input
              type="radio"
              name="single-answer"
              value={answer.id}
              hidden
            />
            <div className={`myinterview-widget-assessment__checkmark ${answer.selected ? 'myinterview-widget-assessment__checkmark--selected' : ''}`}>
              <Check />
            </div>
            <Text size="S-Regular">{answer.label}</Text>
          </label>
        ))}
      </form>
    </div>
  );
};
